import { render, staticRenderFns } from "./shareLinkDialog.vue?vue&type=template&id=d5354822&scoped=true&"
import script from "./shareLinkDialog.vue?vue&type=script&lang=js&"
export * from "./shareLinkDialog.vue?vue&type=script&lang=js&"
import style0 from "./shareLinkDialog.vue?vue&type=style&index=0&id=d5354822&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5354822",
  null
  
)

export default component.exports